import { db } from "services/firebase";
import { METRIC_LABELS, buildReportTableRows } from "./reportingTransforms";

export { METRIC_LABELS } from "./reportingTransforms";

export async function listInstitutionReports(institutionId, limit = 12) {
  if (!institutionId) return [];
  const snap = await db
    .collection("reportingAggregates")
    .where("institutionId", "==", institutionId)
    .orderBy("periodKey", "desc")
    .limit(limit)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function listInstitutionReportsInRange(
  institutionId,
  startPeriodKey,
  endPeriodKey,
) {
  if (!institutionId || !startPeriodKey || !endPeriodKey) return [];
  const snap = await db
    .collection("reportingAggregates")
    .where("institutionId", "==", institutionId)
    .where("periodKey", ">=", startPeriodKey)
    .where("periodKey", "<=", endPeriodKey)
    .orderBy("periodKey", "asc")
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getCurrentMonthReport(institutionId) {
  const rows = await listInstitutionReports(institutionId, 1);
  return rows[0] || null;
}

/**
 * Build a CSV string from reportingAggregates rows.
 */
export function buildReportsCsv(
  reports = [],
  tciNameById = {},
  options = {},
) {
  const {
    dimension = "institution",
    metrics = Object.keys(METRIC_LABELS),
  } = options;

  const tableRows = buildReportTableRows(reports, {
    dimension,
    metrics,
    tciNameById,
  });

  const metricKeys = metrics.filter((key) => METRIC_LABELS[key]);
  const header = [
    "periodKey",
    "tciId",
    "tciName",
    ...metricKeys,
  ];
  const lines = [header.join(",")];

  tableRows.forEach((row) => {
    lines.push(
      [
        row.periodKey || "",
        row.tciId || "",
        row.tciName ? JSON.stringify(row.tciName) : "",
        ...metricKeys.map((key) => row.metrics?.[key] ?? ""),
      ].join(","),
    );
  });

  return lines.join("\n");
}

export function downloadReportsCsv(
  reports,
  tciNameById,
  filename = "institution-reports.csv",
  options = {},
) {
  const csv = buildReportsCsv(reports, tciNameById, options);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export async function listPromptTestCasesForPrompt(promptId, limit = 50) {
  if (!promptId) return [];
  const snap = await db
    .collection("promptTestCases")
    .where("promptId", "==", promptId)
    .where("isActive", "==", true)
    .limit(limit)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}
